import React from 'react';
import Button from './button';

export default function Danger(props) {
  return <Button variant="destructive" {...props} />;
}
